<main>
    <h1 mat-dialog-title> {{'CancelAppointment' | translate}} </h1>

    <section class="cancel_appointment_dialog__hours">
      <div mat-dialog-content>
        <p class="delete-dialog-content">
          {{"AreYouSureToCancelFirstPart" | translate}} <b> {{appointment.dataItem.Services[0].ServiceName}}, </b>
          {{"AreYouSureToCancelSecondPart" | translate}} <b> {{iAppointmentSchedule}} </b> {{"Definitely" | translate}}?
        </p>
      </div>
    </section>

    

    <section class="schedulerLoading" *ngIf="appointmentcancellation">
      <div  class="pulsing" >
        <mat-spinner [diameter]="50" ></mat-spinner>
      </div>
      <p class="pulsing" >{{ "Loading" | translate }}...</p>
    </section>

    <mat-dialog-actions align="center" *ngIf="!appointmentcancellation"> 
        <button mat-dialog-close class="dialog__button">
          {{"Cancel" | translate}}
        </button>
        <button
          class="dialog__button dialog__button--fill"
          (click)="onCancelAppointment()"
        >
          {{"Accept" | translate}}
        </button>
      </mat-dialog-actions>
</main>